// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oo-0";
export var discountCodeInput = "_oo-1";